import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import _ from "lodash";

const PolicyTerms = ({ open = false, onBack = () => {}, noBTN = false }) => {
  const styleShow = { display: open ? "block" : "none" };

  const goBack = () => {
    onBack();
  };

  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, [open]);

  return (
    <div style={styleShow}>
      <Helmet>
        <title>โคอะลา มาร์ช</title>
        <meta name="title" content="โคอะลา มาร์ช" />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="โคอะลา มาร์ช" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="" />
      </Helmet>

      <div id="pagePolicy-Terms">
        <main>
          <div className="wrapContent">
            <section id="pTitlePage">
              <div className="bTitlePage">
                {!noBTN ? <a className="btnIconBack" onClick={goBack}></a> : <a></a>}

                <h2>ข้อกำหนดกติกาและเงื่อนไข</h2>
              </div>
            </section>

            <section id="pContent">
              {/* กิจกรรม */}
              <div className="bContent bCard">
                <h1>เงื่อนไขการร่วมกิจกรรมแลกรับของรางวัล</h1>
                <div className="bDetails">
                  <p>1. รายละเอียดของรางวัลสำหรับการใช้พอยต์แลกของรางวัล มีดังนี้</p>
                  <em style={{ color: "red" }}>*ของรางวัลมีจำนวนจำกัด</em>
                  <p>1.1 แก้วน้ำโคอะลา มาร์ช มูลค่า 199 บาท สามารถแลกได้โดยใช้พอยต์สะสม 15 พอยต์ (จำนวนจำกัด 500 สิทธิ์)</p>
                  <p>1.2 กระเป๋าคล้องคอโคอะลา มาร์ช มูลค่า 299 บาท สามารถแลกได้โดยใช้พอยต์สะสม 20 พอยต์ (จำนวนจำกัด 200 สิทธิ์)</p>
                  <p>1.3 พวงกุญแจตุ๊กตาโคอะลา มาร์ช (แบบสุ่ม) มูลค่า 499 บาท สามารถแลกได้โดยใช้พอยต์สะสม 30 พอยต์ (จำนวนจำกัด 2,000 สิทธิ์)</p>
                  <p>1.4 กระบอกน้ำเก็บความเย็นโคอะลา มาร์ช(แบบสุ่ม) มูลค่า 499 บาท สามารถแลกได้โดยใช้พอยต์สะสม 25 พอยต์ (จำนวนจำกัด 440 สิทธิ์)</p>
                  <p>1.5 รองเท้าสลิปเปอร์โคอะลา มาร์ช มูลค่า 599 บาท สามารถแลกได้โดยใช้พอยต์สะสม 30 พอยต์ (จำนวนจำกัด 300 สิทธิ์)</p>
                  <p>1.6 Koala's March X'mas Crystal Ball มูลค่า 599บาท สามารถแลกได้โดยใช้พอยต์สะสม 35 พอยต์ (จำนวนจำกัด 40 สิทธิ์)</p>
                  <p>1.7 เก้าอี้ปิกนิกโคอะลา มาร์ช มูลค่า 899 บาท สามารถแลกได้โดยใช้พอยต์สะสม 75 พอยต์ (จำนวนจำกัด 800 สิทธิ์)</p>
                  <p>1.8 Starbucks card มูลค่า 150 บาท สามารถแลกได้โดยใช้พอยต์สะสม 30 พอยต์ (จำนวนจำกัด 100 สิทธิ์)</p>
                  <p>1.9 Tops Gift Voucher มูลค่า 100 บาท สามารถแลกได้โดยใช้พอยต์สะสม 30 พอยต์ (จำนวนจำกัด 200 สิทธิ์)</p>
                  <p>1.10 บัตรของขวัญสำหรับใช้ที่โลตัสทุกสาขา มูลค่า 100 บาท สามารถแลกได้โดยใช้พอยต์สะสม 30 พอยต์ (จำนวนจำกัด 200 สิทธิ์)</p>
                  <p>1.11 บัตรชมภาพยนตร์ Major Cineplex มูลค่า 220 บาท สามารถแลกได้โดยใช้พอยต์สะสม 30 พอยต์ (จำนวนจำกัด 100 สิทธิ์)</p>
                  <p>1.12 Bundle ตุ๊กตาโคอะลา มาร์ช พร้อมกระเป๋าใส มูลค่า 799 บาท สามารถแลกได้โดยใช้พอยต์สะสม 50 พอยต์ (จำนวนจำกัด 500 สิทธิ์)</p>
                  <p>1.13 Bundle ตุ๊กตาโคอะลา มาร์ชขนฟู พร้อมกระเป๋าใส มูลค่า 799 บาท สามารถแลกได้โดยใช้พอยต์สะสม 50 พอยต์ (จำนวนจำกัด 500 สิทธิ์)</p>
                  <p>1.14 Bundle ตุ๊กตาแองเจิลโคอะลา มาร์ช พร้อมกระเป๋าใส มูลค่า 799 บาท สามารถแลกได้โดยใช้พอยต์สะสม 50 พอยต์ (จำนวนจำกัด 500 สิทธิ์)</p>
                  <p>1.15 Bundle ตุ๊กตาเดวิลล์โคอะลา มาร์ช พร้อมกระเป๋าใส มูลค่า 799 บาท สามารถแลกได้โดยใช้พอยต์สะสม 50 พอยต์ (จำนวนจำกัด 500 สิทธิ์)</p>
                  <p>1.16 Bundle ตุ๊กตาผึ้งโคอะลา มาร์ช พร้อมกระเป๋าใส มูลค่า 799 บาท สามารถแลกได้โดยใช้พอยต์สะสม 50 พอยต์ (จำนวนจำกัด 500 สิทธิ์)</p>

                  <p>
                    <strong>หมายเหตุ:</strong> พอยต์ที่ใช้แลกของรางวัลไปแล้ว จะถูกลบออกจากพอยต์สะสม เช่น มีพอยต์สะสม 100 พอยต์ แลกของรางวัล 50 พอยต์ จะทำให้พอยต์สะสมคงเหลือสุทธิ 50 พอยต์ ของรางวัลจะถูกจัดส่งภายใน 60
                    วันหลังจากที่ท่านแลกของรางวัล
                  </p>

                  <h2>รายละเอียด กติกา และเงื่อนไขการร่วมกิจกรรมและแลกพอยต์รับของรางวัล</h2>
                  <p>1. สำหรับผู้ร่วมกิจกรรมที่แลกพอยต์รับรางวัลจะต้องเป็นบุคคลธรรมดา ไม่จำกัดสัญชาติ มีภูมิลำเนาและถิ่นที่อยู่ปัจจุบันในประเทศไทยเท่านั้น</p>
                  <p>2. หลังจากผู้เข้าร่วมกิจกรรมกดแลกรับของรางวัลแล้ว ของรางวัลจะถูกจัดส่งภายใน 60 วันหลังจากที่กดแลกรับของรางวัล โดยเริ่มนับวันที่ 1 ในวันถัดไป (*ของรางวัลมีจำนวนจำกัด) ท่านสามารถดูจำนวนของรางวัลคงเหลือผ่านเมนู “แลกของรางวัล”</p>
                  <p>3. ของรางวัลไม่สามารถแลก ทอน หรือเปลี่ยนเป็นเงินสดได้ และไม่สามารถโอนสิทธิ์ให้ผู้อื่นได้ บริษัทฯ ขอสงวนสิทธิ์ในการเปลี่ยนแปลง แก้ไข เพิ่ม หรือลดของรางวัลและเงื่อนไขโดยไม่ต้องแจ้งให้ทราบล่วงหน้า</p>
                  <p>
                    4. หากบริษัทฯ ตรวจสอบภายหลังและพบว่าผู้ได้รับรางวัลไม่อยู่ในเงื่อนไขที่กำหนดหรือทำผิดกติกาไม่ว่าส่วนใดส่วนหนึ่ง บริษัทฯ สามารถยกเลิกสิทธิ์ และมอบสิทธิ์ใหม่ให้ผู้ได้รับรางวัลในรายชื่อสำรองได้ รวมถึงขอสงวนสิทธิ์ในการมอบ, ยกเลิก,
                    เพิกถอน, หรือเรียกคืนรางวัลทั้งหมด รวมทั้งเรียกให้ชดใช้ค่าเสียหาย หากมีการใช้สิทธิ์ร่วมรายการโดยทุจริต, ปลอมแปลง, ฉ้อฉล เพื่อให้ได้มาซึ่งสิทธิ์ในรายการนี้โดยมิชอบ
                  </p>
                  <p>
                    5. หากข้อมูลในระบบสูญหายอันเนื่องมาจากเหตุการณ์ไม่คาดคิดใด ๆ เช่น ภัยธรรมชาติการเกิดสถานการณ์ความไม่สงบหรือการโจรกรรมทางคอมพิวเตอร์ ฯลฯ ทางบริษัทฯ จะไม่รับผิดชอบข้อมูลส่วนที่สูญหายนั้น
                    และหากมีเหตุจำเป็นต้องขอข้อมูลใหม่ในช่วงที่กิจกรรมยังไม่สิ้นสุดทางบริษัทฯ จะแจ้งขอข้อมูลของท่านอีกครั้ง
                  </p>
                  <p>6. พนักงานและครอบครัวของบริษัท ไทยลอตเต้ จำกัด, ตัวแทนบริษัท, พนักงานร้านค้าตัวแทนจำหน่าย, เอเจนซี่, คณะกรรมการดำเนินงาน รวมถึงบริษัทที่เกี่ยวข้องกับการจัดกิจกรรม ไม่มีสิทธิเข้าร่วมหรือรับของรางวัลในกิจกรรมนี้</p>
                  <p>
                    7. กรณีพบปัญหาการสะสมพอยต์ผ่านการแสกนหรือกรอกรหัสในกล่องทั้งกรณีไม่พบรหัส รหัสไม่ถูกต้อง หรือรหัสของท่านถูกใช้ไปแล้ว เมื่อแจ้งปัญหาเข้ามาจำเป็นต้องมีหลักฐานดังนี้ กล่องขนมสภาพสมบูรณ์ที่มีรหัสของท่าน (เห็นรหัสชัดเจน
                    ไม่เสียหายหรือถูกดัดแปลงและมีวันผลิต-วันหมดอายุชัดเจน) และหลักฐานการซื้อสินค้า (บิลใบเสร็จ) ที่มีอายุไม่เกิน 7 วันนับจากวันที่ท่านแจ้งพบปัญหา เพื่อให้ทางบริษัทพิจารณาดำเนินการตรวจสอบต่อไป
                  </p>
                  <p>
                    8. เมื่อมีการแจ้งปัญหาการสะสมพอยต์ผ่านการแสกนหรือกรอกรหัสในกล่อง บริษัทฯขอสงวนสิทธิ์ในการอนุมัติหรือปฏิเสธการให้พอยต์ตามดุลยพินิจ หากท่านไม่สามารถแสดงหลักฐานครบถ้วนตามที่ระบุไว้ข้างต้น
                    บริษัทขอสงวนสิทธิ์ในการไม่อนุมัติพอยต์จากการแสกนรหัสดังกล่าว
                  </p>
                  <p>9. กรณีมีข้อขัดแย้งหรือข้อพิพาท คำตัดสินของคณะกรรมการถือเป็นเด็ดขาดและสิ้นสุด</p>
                  <p>10. รูปภาพในกิจกรรมทั้งหมดใช้เพื่อประกอบการโฆษณาเท่านั้น</p>
                  <p>11. บริษัทขอสงวนสิทธิ์ในการปรับเปลี่ยนอัตราหรือจำนวนพอยต์ที่ผู้ใช้งานจะได้รับจากการพิมพ์รหัสในกล่อง Koala’s March และการร่วมกิจกรรมต่าง ๆ ได้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า</p>
                  <p>
                    12. ผู้ร่วมกิจกรรมเข้าใจและรับทราบเป็นอย่างดีถึงวัตถุประสงค์ของกิจกรรมนี้และตกลงยินยอมที่จะให้บริษัทฯ ทำการเก็บรวบรวมส่วนบุคคลที่มีความอ่อนไหว ใช้ข้อมูลส่วนบุคคลของผู้ร่วมกิจกรรม
                    เฉพาะที่จำเป็นสำหรับการร่วมกิจกรรมเป็นไปตามนโยบายของบริษัทฯ และตามข้อบังคับของกฎหมาย และ/หรือเพื่อให้การเข้าร่วมกิจกรรม การแจ้งผล และการรับรางวัลในกิจกรรม
                    ตลอดจนการนำข้อมูลดังกล่าวมาประมวลผลของกิจกรรมนี้ว่าบรรลุวัตถุประสงค์สมบูรณ์อย่างแท้จริง ทั้งนี้ท่านควรตรวจสอบรายละเอียดกติกาและเงื่อนไขนี้เป็นระยะเพื่อรับทราบการเปลี่ยนแปลงที่อาจเกิดขึ้น
                    การที่ท่านเข้ามาใช้งานระบบหมายความว่าท่านยอมรับการเปลี่ยนแปลงนั้น
                  </p>
                  <p>
                    13. ทางบริษัทฯ สงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไข และของรางวัลโดยไม่ต้องแจ้งให้ทราบล่วงหน้า กรณีมีเหตุภัยธรรมชาติ หรืออื่นใด อีกทั้งบริษัทฯ จะไม่รับผิดชอบต่อคุณภาพที่อาจเกิดขึ้นกับรางวัลดังกล่าว หากมีปัญหาเกี่ยวกับคุณภาพ
                    หรือบริการ ผู้ร่วมกิจกรรมจะต้องติดต่อบริษัทที่จัดจำหน่ายอย่างเป็นทางการโดยตรง
                  </p>
                  <p>
                    14. การขอเปลี่ยนของรางวัลจะสามารถทำได้เนื่องจากของรางวัลชำรุดและเสียหายจากการขนส่ง รวมถึงได้รับของรางวัลผิดประเภทจากที่ตนได้ทำการแลกไปเท่านั้น ทางบริษัทฯ ขอสงวนสิทธิ์ในการเปลี่ยนของรางวัลในกรณีดังกล่าวได้ไม่เกิน 2 ครั้ง
                    โดยจำเป็นต้องส่งของรางวัลที่ชำรุดหรือเสียหายกลับมาให้ทางบริษัทฯ เป็นที่เรียบร้อยก่อน หลังจากนั้นทางบริษัทฯ จึงจะจัดส่งของรางวัลชิ้นใหม่ไปให้ และต้องแจ้งขอเปลี่ยนของรางวัลภายใน 15 วันทำการหลังจากที่ของรางวัลได้ถูกจัดส่งสำเร็จ
                    อีกทั้งของรางวัลชิ้นใหม่จะเป็นของประเภทเดียวกันกับที่แลกมา ไม่สามารถขอเปลี่ยนเป็นขอรางวัลชนิดอื่นแทนได้
                  </p>
                  <p>15. เมื่อทำการแลกของรางวัลแล้ว ทางบริษัทฯขอสงวนสิทธิ์ในการยกเลิก แก้ไขรายการแลกของรางวัลนั้น ๆ และขอสงวนสิทธิ์ในการคืนพอยต์ที่ใช้แลกของรางวัลที่สำเร็จไปแล้วทุกกรณี</p>
                  <p>16. ของรางวัลมีจำนวนจำกัด ท่านสามารถตรวจสอบจำนวนคงเหลือผ่านริชเมนูหัวข้อ “แลกของรางวัล”</p>
                  <p>17. ติดตามกิจกรรมพิเศษและศึกษารายละเอียดเพิ่มเติมได้ที่ LINE OA @koalas-march</p>
                  <p>ข้าพเจ้าได้อ่านและเข้าใจ กติกาและเงื่อนไขนี้เป็นอย่างดีแล้ว และให้ความยินยอมให้ข้อมูลแก่บริษัทฯ ในการใช้ข้อมูลส่วนบุคคลของข้าพเจ้าเพื่อส่งข้อมูลกิจกรรมส่งเสริมการขายและการตลาดต่าง ๆ ที่บริษัทฯ ต้องการจะสื่อสารในแคมเปญต่อๆ ไป</p>
                </div>
              </div>

              {!noBTN && (
                <div className="bBtn">
                  <a onClick={goBack} className="btn">
                    ย้อนกลับ
                  </a>
                </div>
              )}
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};

export default PolicyTerms;
